import { chooseBestImage } from '../../../common/resizer';
import Action from '../../Action';
// Avif
import bfgImageAvif from './assets/bfg.png?as=avif&width=150';
// PNG
import bfgImage from './assets/bfg.png?as=png&width=150';
// Webp
import bfgImageWebp from './assets/bfg.png?as=webp&width=150';
import bpImageAvif from './assets/bp.png?as=avif&width=150';
import bpImage from './assets/bp.png?as=png&width=150';
import bpImageWebp from './assets/bp.png?as=webp&width=150';
import brickouestImageAvif from './assets/brickouest.png?as=avif&width=150';
import brickouestImage from './assets/brickouest.png?as=png&width=150';
import brickouestImageWebp from './assets/brickouest.png?as=webp&width=150';
import brickstuffImageAvif from './assets/brickstuff.png?as=avif&width=150';
import brickstuffImage from './assets/brickstuff.png?as=png&width=150';
import brickstuffImageWebp from './assets/brickstuff.png?as=webp&width=150';
import brickwarriorsImageAvif from './assets/brickwarriors.png?as=avif&width=150';
import brickwarriorsImage from './assets/brickwarriors.png?as=png&width=150';
import brickwarriorsImageWebp from './assets/brickwarriors.png?as=webp&width=150';
import chtilugImageAvif from './assets/chtilug.png?as=avif&width=150';
import chtilugImage from './assets/chtilug.png?as=png&width=150';
import chtilugImageWebp from './assets/chtilug.png?as=webp&width=150';
import eurobricksImageAvif from './assets/eurobricks.png?as=avif&width=150';
import eurobricksImage from './assets/eurobricks.png?as=png&width=150';
import eurobricksImageWebp from './assets/eurobricks.png?as=webp&width=150';
import legoImageAvif from './assets/lego.png?as=avif&width=150';
import legoImage from './assets/lego.png?as=png&width=150';
import legoImageWebp from './assets/lego.png?as=webp&width=150';
import lpbImageAvif from './assets/lpb.png?as=avif&width=150';
import lpbImage from './assets/lpb.png?as=png&width=150';
import lpbImageWebp from './assets/lpb.png?as=webp&width=150';
import puissancebrickImageAvif from './assets/puissancebrick.png?as=avif&width=150';
import puissancebrickImage from './assets/puissancebrick.png?as=png&width=150';
import puissancebrickImageWebp from './assets/puissancebrick.png?as=webp&width=150';

import * as style from './style.module.css';

const partners = (lng) => ({
  THEBRICKFILMERSGUILD: {
    title: 'The Brickfilmers Guild',
    link: 'http://www.brickfilmersguild.com/',
    image: [bfgImage, bfgImageWebp, bfgImageAvif],
  },
  BRICKPIRATE: {
    title: 'BrickPirate',
    link: 'https://www.brickpirate.net/',
    image: [bpImage, bpImageWebp, bpImageAvif],
  },
  BRICKSTUFF: {
    title: 'BrickStuff',
    link: 'https://www.brickstuff.com/',
    image: [brickstuffImage, brickstuffImageWebp, brickstuffImageAvif],
  },
  BRICKWARRIORS: {
    title: 'BrickWarriors',
    link: 'https://www.brickwarriors.com/',
    image: [brickwarriorsImage, brickwarriorsImageWebp, brickwarriorsImageAvif],
  },
  EUROBRICKS: {
    title: 'EuroBricks',
    link: 'https://www.eurobricks.com/',
    image: [eurobricksImage, eurobricksImageWebp, eurobricksImageAvif],
  },
  LAPETITEBRIQUE: {
    title: lng === 'fr' ? 'La Petite Brique' : 'The Little Brick',
    link: 'https://www.lapetitebrique.com/',
    image: [lpbImage, lpbImageWebp, lpbImageAvif],
  },
  LEGO: {
    title: 'LEGO',
    link: 'https://www.lego.com/',
    image: [legoImage, legoImageWebp, legoImageAvif],
  },
  BRICKOUEST: {
    title: 'Brickouest',
    link: 'https://brickouest.fr/',
    image: [brickouestImage, brickouestImageWebp, brickouestImageAvif],
  },
  PUISSANCEBRICK: {
    title: 'Puissance Brick',
    link: 'https://www.puissancebrick.fr/',
    image: [puissancebrickImage, puissancebrickImageWebp, puissancebrickImageAvif],
  },
  CHTILUG: {
    title: 'Ch\'ti LUG',
    link: 'https://www.chtilug.fr/',
    image: [chtilugImage, chtilugImageWebp, chtilugImageAvif],
  },
});

const PartnerLogo = ({ type, language = 'en' }) => {
  const partner = partners(language)?.[type];
  if (!partner) {
    return null;
  }
  return (
    <Action title={partner.title} action={partner.link}>
      <img className={style.image} alt={partner.title} src={chooseBestImage(partner.image)} loading="lazy" />
    </Action>
  );
};

export default PartnerLogo;
